import { render, staticRenderFns } from "./RetentionTouchpointsWidget.vue?vue&type=template&id=12f85f22&"
import script from "./RetentionTouchpointsWidget.vue?vue&type=script&lang=js&"
export * from "./RetentionTouchpointsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports